import React from "react";
import RecipeDto from "../Common/dtos/RecipeDto";
import { RowFormText } from "../Common/Forms/FormText";
import EntityModal, { ModalMode } from "../Common/EntityModal";
import useUpsertRecipe, { RecipeUpsertDto } from "../../requests/useUpsertRecipe";
import { FormSiteAssignment } from "../Common/SiteAssignment/FormSiteAssignment";
import useGetRecipeSiteAssignment from "../../requests/useGetRecipeSiteAssignment";
import useEntityForm from "../Common/useEntityForm";

interface CreateEditRecipeProps {
  initialRecipe: RecipeDto | null;
  onDismiss: () => void;
  onUpsert: (recipeId: string, recipeName: string) => void;
  mode: ModalMode;
}

export const CreateEditRecipe = (props: CreateEditRecipeProps) => {
  const { hookProps, control, submit, isSaving, loading, loadError, displayMessage, sites } =
    useEntityForm<RecipeUpsertDto, RecipeUpsertDto>({
      initialId: props.initialRecipe?.id,
      defaultValues: {
        name: props.initialRecipe?.name ?? '',
        epaNumber: props.initialRecipe?.epaNumber ?? '',
        ticketNotes: props.initialRecipe?.ticketNotes ?? '',
        siteIds: [],
      },
      useSiteAssignment: options => useGetRecipeSiteAssignment(props.initialRecipe?.id, options),
      useUpsert: options => useUpsertRecipe(props.initialRecipe?.id, options),
      toDto: form => form,
      onSuccess: (recipeId, form) => {
        props.onDismiss();
        props.onUpsert(recipeId, form.name);
      },
    });

  return (<EntityModal
    mode={props.mode}
    entityName="recipe"
    displayMessage={displayMessage}
    loading={loading}
    loadError={loadError}
    renderSiteAssignment={<FormSiteAssignment {...hookProps('siteIds')} control={control} sites={sites} />}
    onHide={props.onDismiss}
    isSaving={isSaving}
    onSubmit={submit}
    renderForm={(<>
      <RowFormText displayName='Recipe Name' {...hookProps('name')}
        options={{
          required: 'Name is required',
          validate: { length: v => v.length < 51 || 'Name cannot be longer than 50 characters' }
        }} />
      <RowFormText displayName='EPA Number' placeholder='EPA number' {...hookProps('epaNumber')}
        options={{
          validate: { length: v => v.length < 51 || 'EPA number cannot be longer than 50 characters' }
        }} />
      <RowFormText displayName='Ticket Notes' {...hookProps('ticketNotes')} />
    </>)} />);
};
